((root, factory) => {
  const api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  else root.MoveCalmlyNavigationState = api;
})(typeof globalThis !== 'undefined' ? globalThis : this, () => {
  function create({ triggers, panelFor, contains }) {
    let active = null;

    function close({ restoreFocus = false } = {}) {
      if (!active) return;
      const trigger = active;
      const panel = panelFor(trigger);
      trigger.setAttribute('aria-expanded', 'false');
      if (panel) panel.hidden = true;
      active = null;
      if (restoreFocus) trigger.focus();
    }

    function open(trigger) {
      if (!trigger) return;
      if (active === trigger) {
        close();
        return;
      }
      close();
      const panel = panelFor(trigger);
      if (!panel) return;
      trigger.setAttribute('aria-expanded', 'true');
      panel.hidden = false;
      active = trigger;
    }

    function escape() {
      if (!active) return false;
      close({ restoreFocus: true });
      return true;
    }

    function outside(target) {
      if (!active) return false;
      const panel = panelFor(active);
      if (contains(active, target) || contains(panel, target)) return false;
      close();
      return true;
    }

    function closeForDialog() { close(); }

    return { open, close, escape, outside, closeForDialog, get active() { return active; }, triggers };
  }

  function init(doc) {
    const triggers = [...doc.querySelectorAll('[data-nav-disclosure]')];
    if (!triggers.length) return null;
    const controller = create({
      triggers,
      panelFor: (trigger) => doc.getElementById(trigger?.dataset.navDisclosure),
      contains: (container, target) => Boolean(container?.contains(target))
    });
    const triggerHandlers = triggers.map((trigger) => {
      const handler = () => controller.open(trigger);
      trigger.addEventListener('click', handler);
      return [trigger, handler];
    });
    const keyHandler = (event) => { if (event.key === 'Escape') controller.escape(); };
    const clickHandler = (event) => { if (!event.target.closest('[data-nav-disclosure]')) controller.outside(event.target); };
    doc.addEventListener('keydown', keyHandler);
    doc.addEventListener('click', clickHandler);
    return Object.assign(controller, {
      destroy() {
        controller.close();
        triggerHandlers.forEach(([trigger, handler]) => trigger.removeEventListener('click', handler));
        doc.removeEventListener('keydown', keyHandler);
        doc.removeEventListener('click', clickHandler);
      }
    });
  }

  return { create, init };
});
